/* eslint-disable no-console */

import { register } from "register-service-worker";

const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
const inNativeWebView = /;\s*wv\)/i.test(ua) || (typeof window !== "undefined" && !!(window as any).Android);

// Workbox in the MAUI WebView intercepts lazy chunks / version.json and
// can leave the boot splash up until "Tap to retry". Browser PWA is fine.
if (!inNativeWebView) {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready() {
      if ('serviceWorker' in navigator) {
        caches.keys().then(function(cacheNames) {
          cacheNames.forEach(function(cacheName) {
            caches.delete(cacheName);
          });
        });
      }
      console.log(
        "App is being served from cache by a service worker.\n" +
          "For more details, visit https://goo.gl/AFskqB"
      );
    },
    registered() {
      console.log("Service worker has been registered.");
    },
    cached() {
      console.log("Content has been cached for offline use.");
    },
    updatefound() {
      console.log("New content is downloading.");
    },
    updated() {
      console.log("New content is available; please refresh.");
    },
    offline() {
      console.log(
        "No internet connection found. App is running in offline mode."
      );
    },
    error(error) {
      console.error("Error during service worker registration:", error);
    },
  });
}
